import React from "react"
import { Affix, Button, Card, Col, Form, Input, Row } from "antd"
import { FORM_TYPE_ADD } from "../../enums/FormTypes"
import FormFileUploader from "../customFormItems/FormFileUploader"
import useSeoFormItems from "../../hooks/useSeoFormItems"

const ChannelForm = ({ onFinish, initialValues, formType }) => {
  const [form] = Form.useForm()
  const seoItems = useSeoFormItems({ form, itemId: initialValues?.id })

  return (
    <Form
      scrollToFirstError
      initialValues={initialValues}
      onFinish={onFinish}
      layout={"vertical"}
      form={form}
    >
      <Row gutter={16}>
        <Col span={16}>
          <Card title="Canale">
            <Form.Item
              label="Nome"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Immagine" name="portrait_id">
              <FormFileUploader accept={"image/*"} />
            </Form.Item>
            <Form.Item label="Descrizione" name="description">
              <Input />
            </Form.Item>
          </Card>
        </Col>
        <Col span={8}>
          <Affix offsetTop={16}>
            <Card title="SEO">{seoItems}</Card>
          </Affix>
        </Col>
      </Row>

      <br />

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {formType === FORM_TYPE_ADD ? "inserisci" : "aggiorna"}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default ChannelForm
